<div class="close-icon" mat-button (click)="dialogRef.close()"></div>
<div mat-dialog-title>
  <h2 style="font-family: Roboto, 'Helvetica Neue', sans-serif;">Edit Project: {{project.name}}</h2>
</div>
<div mat-dialog-content>
<div class="project-properties-component" *ngIf='project != null'>
    <div style="margin: 10px 10px 10px 10px">

        <alert></alert>

      <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; ; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;" >

            <div style="flex:20%">
                <mat-form-field class="example-full-width">
                  <mat-label>Project Name</mat-label>
                    <input matInput

                        name="projectName"
                        [(ngModel)]="project.name"
                        required
                        [disabled]="projectReadOnly">
                </mat-form-field>
            </div>

            <div class="form-group"
                style="flex:20%">
                <mat-form-field>
                  <mat-label>Due Date</mat-label>
                    <input matInput
                        [matDatepicker]="picker"

                        [(ngModel)]="project.dueDate"
                        name="dueDate"
                        required
                           [disabled]="projectReadOnly">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </div>

            <div style="flex:20%">
                <mat-form-field class="project-description-width">
                  <mat-label>Project Description</mat-label>
                    <input matInput

                        name="projectDescription"
                        [(ngModel)]="project.description"
                           [disabled]="projectReadOnly">
                </mat-form-field>
            </div>

        <div style="flex:20%" *ngIf="hasLeveledSubItems">
          <mat-form-field>
            <mat-label>Level</mat-label>
            <mat-select
                        [(ngModel)]="maxLevel"
                        name="maxLEVel"
                        (ngModelChange)="updateLeveledSelection()">
              <mat-option *ngFor="let level of levels" [value]="level">
                {{level}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div style="flex:15%" *ngIf="itProfiles">
          <mat-form-field>
            <mat-label>IT Profile</mat-label>
            <mat-select multiple
                        [(ngModel)]="selectedItProfile"
                        name="maxLEVel"
                        (ngModelChange)="updateRecommendedControls()">
              <mat-option [value]="itProfile" *ngFor="let itProfile of itProfiles">
                {{itProfile.name || "Default"}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div style="flex:20%">
          <mat-form-field>
            <mat-label>Workstreams</mat-label>
            <mat-select multiple="true"
                        [(ngModel)]="project.workstreamIds"
                        name="workstreamIds">
              <mat-option [value]="workstream.workstreamId" *ngFor="let workstream of workstreams">
                {{workstream.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div style="flex:15%">
          <mat-form-field>
            <mat-label>Action Plan Sets</mat-label>
            <mat-select
              [(ngModel)]="project.actionPlanTemplateSetIds"
              name="actionPlanTemplateSetIds" multiple="true">
              <mat-option [value]="set.id" *ngFor="let set of actionPlanTemplateSets">
                {{set.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div style="flex:15%">
          <mat-form-field>
            <mat-label>ICS Sets</mat-label>
            <mat-select
              [(ngModel)]="project.implementationControlStatementSetIds"
              name="implementationControlStatementSetIds" multiple="true">
              <mat-option [value]="set.id" *ngFor="let set of implementationControlStatementSets">
                {{set.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

      </div>

      <div style="display: flex; flex-direction: row; justify-content: start; align-items: start">

        <div class="form-group"
             style="flex:25%">
          <mat-form-field>
            <mat-label>Managers</mat-label>
            <mat-select [(ngModel)]="assignedClientManagers"
                        name="assignedClientManagers"
                        multiple
                        (change)="updateAssignedUsers()"
                        [disabled]="projectReadOnly">
              <mat-option *ngFor="let clientManager of clientManagers" [value]="clientManager.userId">
                {{getFullName(clientManager)}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="form-group"
             style="flex:25%">
          <mat-form-field>
            <mat-label>Users</mat-label>
            <mat-select [(ngModel)]="assignedClients"
                        name="assignedClients"
                        multiple
                        (change)="updateAssignedUsers()"
                        [disabled]="projectReadOnly">
              <mat-option *ngFor="let client of clients" [value]="client.userId">
                {{getFullName(client)}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div style="flex:5px"></div>

        <div class="form-group"
             style="flex:25%">
          <mat-form-field>
            <mat-label>Advisor Leads</mat-label>
            <mat-select [(ngModel)]="assignedConsultantManagers"
                        name="assignedConsultantManagers"
                        multiple
                        (change)="updateAssignedUsers()"
                        [disabled]="projectReadOnly">
              <mat-select-trigger><div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"><span *ngFor="let advisorLead of notTenant(assignedConsultantManagers);let i = index"><span *ngIf="i > 0">, </span><span>{{getFullNameId(advisorLead)}}</span></span></div></mat-select-trigger>
              <mat-option *ngFor="let advisorLead of advisorLeads" [value]="advisorLead.userId">
                {{getFullName(advisorLead)}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div style="flex:5px"></div>

        <div class="form-group"
             style="flex:25%">
          <mat-form-field>
            <mat-label>Advisor Staff</mat-label>
            <mat-select [(ngModel)]="assignedConsultants"
                        name="assignedConsultants"
                        multiple
                        (change)="updateAssignedUsers()"
                        [disabled]="projectReadOnly">
              <mat-option *ngFor="let advisor of advisors" [value]="advisor.userId">
                {{getFullName(advisor)}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div style="flex:0.5%"></div>

        <div class="form-group"
             style="flex:15%">
          <mat-form-field>
            <mat-label>Assessors</mat-label>
            <mat-select [(ngModel)]="assignedAssessors"
                        name="assignedAssessors"
                        multiple
                        (change)="updateAssignedUsers()"
                        [disabled]="projectReadOnly">
              <mat-option *ngFor="let assessor of assessors" [value]="assessor.userId">
                {{getFullName(assessor)}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div style="flex:0.5%"></div>

        <div class="form-group"
             style="flex:15%">
          <mat-form-field>
            <mat-label>Workstream Users</mat-label>
            <mat-select [(ngModel)]="assignedWorkstreamUsers"
                        name="assignedAssessors"
                        multiple
                        (change)="updateAssignedUsers()"
                        [disabled]="projectReadOnly">
              <mat-option *ngFor="let workstreamUSer of workstreamUsers" [value]="workstreamUSer.userId">
                {{getFullName(workstreamUSer)}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="form-group"
             style="flex:15%"
             *ngIf="isAutonomyEnabled">
          <mat-form-field>
            <mat-label>Fleet</mat-label>
            <mat-select [(ngModel)]="project.fleetId"
                        name="fleetId">
              <mat-option [value]="null">Standalone</mat-option>
              <mat-option *ngFor="let fleet of fleets" [value]="fleet.fleetId">
                {{fleet.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="form-group"
             style="flex:15%" *ngIf="project.isPartner">
          <mat-form-field>
            <mat-label>Vendors</mat-label>
            <mat-select [(ngModel)]="assignedVendors"
                        name="assignedVendors"
                        multiple
                        (change)="updateAssignedUsers()"
                        [disabled]="projectReadOnly">
              <mat-option *ngFor="let partner of partners" [value]="partner">
                {{partner.fullName}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

      </div>

      <div style="display: flex; flex-direction: row;" *ngIf="hasParents">
        <mat-label style="padding-right: 20px; white-space: nowrap;">
          Treatment for Parent Controls:
        </mat-label>
        <div style="flex:0 0 2%"></div>
        <div style="flex:0 0 auto">
          <mat-checkbox
            class="example-margin"
            [checked]="!project.displayParentRows"
            (change)="project.displayParentRows = !$event.checked"
          >
            Hide Display
          </mat-checkbox>
        </div>

        <div style="flex:0 0 2%">
        </div>
        <div style="flex:0 0 auto" *ngIf="project.displayParentRows">
          <mat-label
            style="font-weight: bold; line-height: 24px; height: 24px; vertical-align: bottom; margin-right: 10px; cursor: pointer;"
            (click)="project.isParentContainer = false">Actionable
          </mat-label>
          <mat-slide-toggle
            class="example-margin"
            [(ngModel)]="project.isParentContainer"
          >
            Grouping Only
          </mat-slide-toggle>
        </div>
      </div>

      <ng-container *ngFor="let complianceArea of complianceAreas">

        <p-treeTable [value]="[complianceArea]"
                 exportFilename="projects"
                #table
                     selectionMode="checkbox"
                     [(selection)]="selectedItems"
                     (selectionChange)="updateLevel()"
        >

          <ng-template pTemplate="header">
            <tr>
              <th>Name</th>
              <th style="width: 80px;" *ngIf="hasRank[complianceArea['complianceAreaId']]"><mat-checkbox [checked]="low[complianceArea['complianceAreaId']]" labelPosition="before" (change)="lowChanged(complianceArea, $event)">Low</mat-checkbox></th>
              <th style="width: 80px;" *ngIf="hasRank[complianceArea['complianceAreaId']]"><mat-checkbox [checked]="medium[complianceArea['complianceAreaId']]" labelPosition="before" (change)="mediumChanged(complianceArea, $event)">Medium</mat-checkbox></th>
              <th style="width: 80px;" *ngIf="hasRank[complianceArea['complianceAreaId']]"><mat-checkbox [checked]="high[complianceArea['complianceAreaId']]" labelPosition="before" (change)="highChanged(complianceArea, $event)">High</mat-checkbox></th>
              <th style="width: 110px;">Due date</th>
              <th style="overflow:visible;width:180px">Owner</th>
              <th style="overflow:visible;width:180px">Recurring</th>
              <th style="overflow:visible;width:180px">Review Required</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
            <tr [ttRow]="rowNode" [ttSelectableRow]="rowNode">
              <td>
                <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                <p-treeTableCheckbox [value]="rowNode" [disabled]="projectReadOnly || rowNode.node.disabled"></p-treeTableCheckbox>
                <span style="display: inline-block; width: 20px;"><img src="../../../assets/icon/hammer.svg" *ngIf="selectedItProfile && recommendedControlIds.indexOf(rowNode.node.controlItemId) >= 0" style="width:16px;" /></span>
                {{rowData.name}}
              </td>
              <td *ngIf="hasRank[complianceArea['complianceAreaId']]"><span class="pi pi-check" *ngIf="rowNode.node.isLow"></span></td>
              <td *ngIf="hasRank[complianceArea['complianceAreaId']]"><span class="pi pi-check" *ngIf="rowNode.node.isMedium"></span></td>
              <td *ngIf="hasRank[complianceArea['complianceAreaId']]"><span class="pi pi-check" *ngIf="rowNode.node.isHigh"></span></td>
              <td>
                <mat-form-field class="date-row">
                  <input matInput
                         [matDatepicker]="picker"
                         [(ngModel)]="rowData.dueDate"
                         name="nodeDueDate"
                         (dateChange)="onNodeDateChanged('change', $event, rowNode.node)">

                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
              </td>

              <td>
                <mat-select placeholder="Select client"
                            [(ngModel)]="rowData.assignedClientList"
                            multiple
                            (selectionChange)="onNodeClientChanged($event, $event.value, rowNode.node)"
                            [disabled]="projectReadOnly"
                >
                  <mat-option *ngFor="let user of assignedUsersWithoutPartners" [value]="user">
                    {{user.fullName}}
                  </mat-option>
                  <mat-option (click)="selectAllPartners($event, $event['value'], rowNode.node)" disabled="true" value="-1"
                              class="no-checkbox" *ngIf="project.isPartner">
                    <div style="font-weight: bold">Vendor Users</div>
                  </mat-option>
                  <mat-option *ngFor="let user of assignedVendors" [value]="user">
                    <div style="margin-left: 20px">{{user.fullName}}</div>
                  </mat-option>
                </mat-select>
              </td>
              <td>
                <p-select [options]="recurringList"
                            [(ngModel)]="rowData.recurring"
                            optionLabel="label"
                            [style]="{'overflow':'visible', 'width':'74px'}"
                            (onChange)="onNodeRecurringChanged($event, $event.value, rowNode.node)"
                            [disabled]="projectReadOnly"
                >
                </p-select>
              </td>
              <td>
                <p-checkbox (onChange)="changeReviewRequiredChecked($event, rowNode.node)"
                            [(ngModel)]="rowData.reviewRequired"
                            [disabled]="projectReadOnly"
                >
                </p-checkbox>
              </td>
            </tr>
          </ng-template>





        </p-treeTable>
      </ng-container>

    </div>
</div>
</div>

<div mat-dialog-actions>
<div style="display: flex; flex-direction: row; justify-content: start; align-items: start; ; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;" *ngIf="projectLoaded">
  <button mat-raised-button [disabled]="loading || projectReadOnly" (click)="onSave()">Save</button>
  <img *ngIf="loading" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
  <button mat-raised-button (click)="onClose()">Cancel</button>


  <button mat-raised-button mwlConfirmationPopover [title]="'Delete Project'" [popoverMessage]="'You are going to delete this project. Are you sure?'" [appendToBody]="true"
          [confirmText]="'Yes'" [cancelText]="'No'" placement="top" (confirm)="deleteProject()"
          style="border-radius: 6px;margin-right: 10px; align-self: flex-end"
          class="button" [disabled]="isDeleting || projectReadOnly || !canDelete">
    <i class="fa fa-trash"></i>
    Delete Project
  </button>
  <img *ngIf="isDeleting" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />

</div>
</div>
